import { mapState } from 'vuex'

export default {
  props: {
    params: Object,
    error: Object,
    edition: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      productBestoveOptions: [
        { name: 'Poële', id: 'Stove' },
        { name: 'Cheminée', id: 'Hearth' }
      ]
    }
  },
  computed: {
    ...mapState(['prFormInfos'])
  },
  methods: {
    validate (ref) {
      this.$refs[ref].validate()
    }
  },
  watch: {
    'params.product_type' () {
      this.$refs.selectProductId.clearSelection()
    }
  }
}
